import modal from './modal';

export default (editor, opts = {}) => {
    const $ = editor.$;
    const pfx = editor.getConfig().stylePrefix;
    const mdlClass = `${pfx}mdl-dialog-wx`;
    let primaryEl = '';
    let menusEl;
    const domEl = $(`#${pfx}mdl-tools`);
    const menus = ['Layers', 'Selectors', 'Ruler Bar', '', 'Gridlines', 'Snap-to-Objects', ['Dev Mode']];

    menus.forEach(menu => {
        let premium;
        typeof menu === 'object' && (menu = menu[0]) && (premium = 1);
        primaryEl += menu ? `<div data-filter="${menu}">
            <div class="gjs-field-wrp gjs-field-wrp--checkbox" style="display:inline-block" data-input="">
                <label class="gjs-field gjs-field-checkbox" data-input="">
                    <input type="checkbox" name="${menu}">
                    <i class="gjs-chk-icon"></i>
                </label>
            </div>
            <span>${premium ? `${menu} <i class="fa fa-lock"></i>` : menu}</span>
            </div>` : `<div data-filter="${menu}">${menu}</div>`
    });
    menusEl = domEl.length ? domEl :
        $(`<div id="${pfx}mdl-tools" class="${pfx}mdl-options-container ${pfx}fadein">
            <div class="${pfx}mdl-options-primary">${primaryEl}</div>
            <div class="${pfx}mdl-illustration">
            </div>
        </div>`);

    if (!domEl.length) {
        const checks = menusEl.find('input');
        checks.get(0).checked = true;
        checks.get(1).checked = true;
        checks.get(4).checked = true;
        checks.on('change', function (e) {
            switch (this.name) {
                case "Layers":
                    const btns = $(`.${pfx}pn-views span`);
                    if (this.checked) {
                        editor.Layers.render().style.display = '';
                        btns.css('width', '33.3333%');
                        btns.get(2).style.display = '';
                    } else {
                        editor.Layers.render().style.display = 'none';
                        btns.get(0).style.width = '50%';
                        btns.get(1).style.width = '50%';
                        btns.get(2).style.display = 'none';
                    }
                    break;
                case "Selectors":
                    this.checked && (editor.Selectors.render().style.display = '');
                    !this.checked && (editor.Selectors.render().style.display = 'none');
                    break;
                case "Ruler Bar":
                    opts.rulerBar && opts.rulerBar(this.checked);
                    break;
                case "Gridlines":
                    this.checked && editor.runCommand('sw-visibility');
                    !this.checked && editor.stopCommand('sw-visibility');
                    break;
                case "Snap-to-Objects":
                    this.checked && editor.setDragMode('translate');
                    !this.checked && editor.setDragMode('translate');
                    break;
                case "Dev Mode":
                    opts.devMode && opts.devMode(this.checked);
                    break;
                default:
                    break;
            }
        });
    }

    modal(editor, mdlClass, 'Tools', menusEl.get(0));
};